export default __webpack_public_path__ + "static/media/ArticleThumbnail.208732b1.svg";